import { resolve } from "inversify-react";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { actions as homeActions } from "../../actions/home.actions";
import { actions } from "../../actions/main.actions";
import { actions as nameActions } from "../../actions/name.actions";
import Button from "../../core/ui/button";
import Container from "../../core/ui/container";
import Grid, { Col } from "../../core/ui/grid";
import Icon from "../../core/ui/icon";
import FormInput from "../../core/ui/input";
import Modal from "../../core/ui/modal";
import { delayFunction } from "../../core/utils/object";
import IdentityService from "../../services/identity.service";
import {IApplicationState, Identity} from "../../typings";

interface IResetPasswordProps extends RouteComponentProps<{uid: string, key: string}> {
    identity: Identity;
}

type ResetPasswordProps = IResetPasswordProps & typeof actions & typeof homeActions;
interface IResetPasswordState {
    uidErrors?: string[];
    keyErrors?: string[];

    generalErrors?: string[];
    detailError?: string;
    success: boolean;
    loading: boolean;

    passwordErrors?: string[];
    retypePasswordErorrs?: string[];
    newPassword: string;
    retypePassword: string;
    missmatch: boolean;
}

class ResetPassword extends React.Component<ResetPasswordProps, IResetPasswordState> {

    @resolve
    public identity: IdentityService;

    constructor(props: any) {
    super(props);
    this.state =  {
            success: false,
            loading: false,
            newPassword: "",
            retypePassword: "",
            missmatch: true,
        };
    }

    public componentDidMount() {

        this.setState({loading: false});

    }

    public resetHandler = () => {
        this.identity.resetPassword(this.props.match.params.uid, this.props.match.params.key, this.state.newPassword).then((result) => {
            this.props.history.push("/");
            this.props.toggleLogin(true, 1);
        })
        .catch((error) => {
            this.setState({
                uidErrors: error.uid,
                keyErrors: error.token,
                generalErrors: error.non_field_errors,
                detailError: error.detail,
                passwordErrors: error.new_password,
                loading: false,
            });
        })
        ;
    }

    public renderErrrors = () => {

        return (
            <React.Fragment>
                    <p>Ops, sorry, your registration is not correct</p>
                    {this.state.uidErrors && this.state.uidErrors.map((item, index) => {
                        return <p className="error general-errors" key={"uid" + index}>{item}</p>;
                    })}

                    {this.state.keyErrors && this.state.keyErrors.map((item, index) => {
                        return <p className="error general-errors" key={"uid" + index}>{item}</p>;
                    })}

                    {this.state.generalErrors && this.state.generalErrors.map((item, index) => {
                        return <p className="error general-errors" key={"uid" + index}>{item}</p>;
                    })}

                    <p className="error">{
                        this.state.detailError
                    }</p>
            </React.Fragment>
        );
    }

    public loginAndChange = () => {
        this.props.history.push("/");
        this.props.toggleLogin(true, 1);
    }

    public ensurePasswords = () => {
        const missmatch = this.state.newPassword != this.state.retypePassword;

        this.setState({retypePasswordErorrs: missmatch ? ["The passwords must be equals"] : [], missmatch});

    }

    public render() {
        return (
            <React.Fragment>
                <Modal
                    visible={true}
                    type="dark"
                    size="complete"
                    closable={true}
                    className="fixed"
                    onCancel={() => this.props.history.push("/")}
                >
                <div className="verification-message">
                    <Grid centered={true}>
                        <Col key="k1" className="center-vertical" size={20}>

                        <div className="iconified wire wire-1 light scale-2 not-mobile">
                            <Icon  type="envelop"/>
                        </div>
                        </Col>
                        <Col key="k2" size={50}>
                        <h1>
                            Type your new password
                        </h1>
                        <div className="iconified wire wire-1 light scale-2 mobile">
                            <Icon  type="envelop"/>
                        </div>
                        {(this.state.keyErrors || this.state.uidErrors || this.state.generalErrors || this.state.detailError) &&
                        this.renderErrrors()}

                            <React.Fragment>
                                    <FormInput
                                        type="password"
                                        style="light"
                                        key="pass1"
                                        errors={this.state.passwordErrors}
                                        value={this.state.newPassword}
                                        onChange={(e) => this.setState({newPassword: e})}
                                        label="Password"

                                    />
                                    <FormInput
                                        type="password"
                                        key="pass2"
                                        style="light"
                                        errors={this.state.retypePasswordErorrs}
                                        value={this.state.retypePassword}
                                        onChange={(e) => this.setState({retypePassword: e}, this.ensurePasswords)}
                                        label="Retype Password"
                                        extraContent={[(<React.Fragment>
                                            <Button key="reset_btn" extraProps={{type: "submit"}} as={<button/>} disabled={this.state.missmatch} onClick={this.resetHandler} presentation="dark" className={"login-btn"}>Reset password</Button>

                                            </React.Fragment>)]}
                                    />
                                </React.Fragment>
                        <p>
                        </p>
                        </Col>
                    </Grid>

                    </div>
                </Modal>
                <Container>

                </Container>
            </React.Fragment>
        );
    }

    public componentWillReceiveProps(nextProps: ResetPasswordProps) {
        if (nextProps.identity.isAuthenticated) {
            this.props.history.push("/");
        }
    }
}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        identity: state.identity,
        ...ownProps,
        };
}
export default connect(mapStateToProps, {...actions, ...nameActions, ...homeActions})(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/account/reset-password.tsx